import { useSelector } from "react-redux";
const useAssignmentDetailsSelector = useSelector;
export {
  useAssignmentDetailsSelector
};
//# sourceMappingURL=hooks.js.map
